import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import { DashboardStackParamList } from '@/types/navigation';
import DashboardScreen from '@/screens/DashboardScreen';
import NotificationsScreen from '@/screens/notifications/NotificationsScreen';
import CallPerformanceScreen from '@/screens/callperformance/CallPerformanceScreen';
import CallDetailScreen from '@/screens/callperformance/CallDetailScreen';
import UnassignedCallsScreen from '@/screens/callperformance/UnassignedCallsScreen';
import { colors, font } from '@/theme/chalkCourt';

const Stack = createStackNavigator<DashboardStackParamList>();

/** Dashboard tab stack: the home screen + the notification center. */
const DashboardNavigator: React.FC = () => (
  <Stack.Navigator
    screenOptions={{
      headerStyle: { backgroundColor: colors.bg, shadowColor: 'transparent' },
      headerTintColor: colors.ink,
      headerTitleStyle: { fontFamily: font.displayBold, fontSize: 20 },
      headerBackTitleVisible: false,
      cardStyle: { backgroundColor: colors.bg },
    }}>
    <Stack.Screen
      name="DashboardHome"
      component={DashboardScreen}
      options={{ headerShown: false }}
    />
    <Stack.Screen
      name="Notifications"
      component={NotificationsScreen}
      options={{ title: 'Notifications' }}
    />
    <Stack.Screen
      name="CallPerformance"
      component={CallPerformanceScreen}
      options={{ title: 'My Call Performance' }}
    />
    <Stack.Screen
      name="CallDetail"
      component={CallDetailScreen}
      options={{ title: 'Call Detail' }}
    />
    <Stack.Screen
      name="UnassignedCalls"
      component={UnassignedCallsScreen}
      options={{ title: 'Unassigned Calls' }}
    />
  </Stack.Navigator>
);

export default DashboardNavigator;
